"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _get = _interopRequireDefault(require("lodash/get"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_20a5p87m4q() {
  var path = "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/product/lib/actions.js";
  var hash = "0cd2fb9d7675e4fe9903ff6fbc225ed5d031fab7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1603853905/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/product/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 28
        },
        end: {
          line: 7,
          column: 2
        }
      },
      "1": {
        start: {
          line: 5,
          column: 35
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "2": {
        start: {
          line: 9,
          column: 29
        },
        end: {
          line: 13,
          column: 2
        }
      },
      "3": {
        start: {
          line: 9,
          column: 48
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "4": {
        start: {
          line: 15,
          column: 27
        },
        end: {
          line: 17,
          column: 2
        }
      },
      "5": {
        start: {
          line: 15,
          column: 34
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "6": {
        start: {
          line: 19,
          column: 23
        },
        end: {
          line: 22,
          column: 2
        }
      },
      "7": {
        start: {
          line: 19,
          column: 35
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "8": {
        start: {
          line: 24,
          column: 34
        },
        end: {
          line: 27,
          column: 2
        }
      },
      "9": {
        start: {
          line: 24,
          column: 46
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "10": {
        start: {
          line: 29,
          column: 26
        },
        end: {
          line: 33,
          column: 2
        }
      },
      "11": {
        start: {
          line: 29,
          column: 67
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "12": {
        start: {
          line: 44,
          column: 13
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "13": {
        start: {
          line: 44,
          column: 34
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "14": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 34
        }
      },
      "15": {
        start: {
          line: 48,
          column: 66
        },
        end: {
          line: 48,
          column: 73
        }
      },
      "16": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 84,
          column: 7
        }
      },
      "17": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 75,
          column: 7
        }
      },
      "18": {
        start: {
          line: 65,
          column: 22
        },
        end: {
          line: 70,
          column: 9
        }
      },
      "19": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 74,
          column: 10
        }
      },
      "20": {
        start: {
          line: 76,
          column: 20
        },
        end: {
          line: 76,
          column: 76
        }
      },
      "21": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 51
        }
      },
      "22": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 18
        }
      },
      "23": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 37
        }
      },
      "24": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 102
        }
      },
      "25": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 22
        }
      },
      "26": {
        start: {
          line: 92,
          column: 14
        },
        end: {
          line: 92,
          column: 70
        }
      },
      "27": {
        start: {
          line: 92,
          column: 25
        },
        end: {
          line: 92,
          column: 70
        }
      },
      "28": {
        start: {
          line: 92,
          column: 37
        },
        end: {
          line: 92,
          column: 70
        }
      },
      "29": {
        start: {
          line: 102,
          column: 25
        },
        end: {
          line: 102,
          column: 92
        }
      },
      "30": {
        start: {
          line: 102,
          column: 36
        },
        end: {
          line: 102,
          column: 92
        }
      },
      "31": {
        start: {
          line: 102,
          column: 48
        },
        end: {
          line: 102,
          column: 92
        }
      },
      "32": {
        start: {
          line: 107,
          column: 17
        },
        end: {
          line: 125,
          column: 1
        }
      },
      "33": {
        start: {
          line: 107,
          column: 28
        },
        end: {
          line: 125,
          column: 1
        }
      },
      "34": {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 26
        }
      },
      "35": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 114,
          column: 3
        }
      },
      "36": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 54
        }
      },
      "37": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 72
        }
      },
      "38": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 117,
          column: 3
        }
      },
      "39": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 51
        }
      },
      "40": {
        start: {
          line: 118,
          column: 2
        },
        end: {
          line: 120,
          column: 3
        }
      },
      "41": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 30
        }
      },
      "42": {
        start: {
          line: 121,
          column: 2
        },
        end: {
          line: 123,
          column: 3
        }
      },
      "43": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 70
        }
      },
      "44": {
        start: {
          line: 124,
          column: 2
        },
        end: {
          line: 124,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 28
          },
          end: {
            line: 5,
            column: 29
          }
        },
        loc: {
          start: {
            line: 5,
            column: 35
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 9,
            column: 29
          },
          end: {
            line: 9,
            column: 30
          }
        },
        loc: {
          start: {
            line: 9,
            column: 48
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 9
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 27
          },
          end: {
            line: 15,
            column: 28
          }
        },
        loc: {
          start: {
            line: 15,
            column: 34
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 24
          }
        },
        loc: {
          start: {
            line: 19,
            column: 35
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 19
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 24,
            column: 34
          },
          end: {
            line: 24,
            column: 35
          }
        },
        loc: {
          start: {
            line: 24,
            column: 46
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 24
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 29,
            column: 26
          },
          end: {
            line: 29,
            column: 27
          }
        },
        loc: {
          start: {
            line: 29,
            column: 67
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 29
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 44,
            column: 14
          }
        },
        loc: {
          start: {
            line: 44,
            column: 34
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 44
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 44,
            column: 34
          },
          end: {
            line: 44,
            column: 35
          }
        },
        loc: {
          start: {
            line: 44,
            column: 46
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 44
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 63,
            column: 10
          },
          end: {
            line: 63,
            column: 11
          }
        },
        loc: {
          start: {
            line: 63,
            column: 22
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 63
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 80,
            column: 11
          },
          end: {
            line: 80,
            column: 12
          }
        },
        loc: {
          start: {
            line: 80,
            column: 23
          },
          end: {
            line: 84,
            column: 5
          }
        },
        line: 80
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 92,
            column: 14
          },
          end: {
            line: 92,
            column: 15
          }
        },
        loc: {
          start: {
            line: 92,
            column: 25
          },
          end: {
            line: 92,
            column: 70
          }
        },
        line: 92
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 92,
            column: 25
          },
          end: {
            line: 92,
            column: 26
          }
        },
        loc: {
          start: {
            line: 92,
            column: 37
          },
          end: {
            line: 92,
            column: 70
          }
        },
        line: 92
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 102,
            column: 25
          },
          end: {
            line: 102,
            column: 26
          }
        },
        loc: {
          start: {
            line: 102,
            column: 36
          },
          end: {
            line: 102,
            column: 92
          }
        },
        line: 102
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 102,
            column: 36
          },
          end: {
            line: 102,
            column: 37
          }
        },
        loc: {
          start: {
            line: 102,
            column: 48
          },
          end: {
            line: 102,
            column: 92
          }
        },
        line: 102
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 107,
            column: 17
          },
          end: {
            line: 107,
            column: 18
          }
        },
        loc: {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 125,
            column: 1
          }
        },
        line: 107
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 107,
            column: 29
          }
        },
        loc: {
          start: {
            line: 107,
            column: 52
          },
          end: {
            line: 125,
            column: 1
          }
        },
        line: 107
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 38
          },
          end: {
            line: 29,
            column: 59
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 57
          },
          end: {
            line: 29,
            column: 59
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 53,
            column: 6
          },
          end: {
            line: 53,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 53,
            column: 18
          },
          end: {
            line: 53,
            column: 27
          }
        }, {
          start: {
            line: 53,
            column: 30
          },
          end: {
            line: 53,
            column: 32
          }
        }],
        line: 53
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 7
          },
          end: {
            line: 54,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 54,
            column: 24
          },
          end: {
            line: 54,
            column: 59
          }
        }, {
          start: {
            line: 54,
            column: 62
          },
          end: {
            line: 54,
            column: 64
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 55,
            column: 6
          },
          end: {
            line: 55,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 15
          },
          end: {
            line: 55,
            column: 34
          }
        }, {
          start: {
            line: 55,
            column: 37
          },
          end: {
            line: 55,
            column: 39
          }
        }],
        line: 55
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 7
          },
          end: {
            line: 56,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 56,
            column: 15
          },
          end: {
            line: 56,
            column: 32
          }
        }, {
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 56,
            column: 37
          }
        }],
        line: 56
      },
      "5": {
        loc: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 57,
            column: 34
          },
          end: {
            line: 57,
            column: 84
          }
        }, {
          start: {
            line: 57,
            column: 87
          },
          end: {
            line: 57,
            column: 89
          }
        }],
        line: 57
      },
      "6": {
        loc: {
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 6
          },
          end: {
            line: 75,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 64
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 32
          }
        }, {
          start: {
            line: 64,
            column: 36
          },
          end: {
            line: 64,
            column: 57
          }
        }],
        line: 64
      },
      "8": {
        loc: {
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 67,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 67,
            column: 25
          }
        }, {
          start: {
            line: 67,
            column: 29
          },
          end: {
            line: 67,
            column: 50
          }
        }],
        line: 67
      },
      "9": {
        loc: {
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 38
          }
        }, {
          start: {
            line: 77,
            column: 42
          },
          end: {
            line: 77,
            column: 50
          }
        }],
        line: 77
      },
      "10": {
        loc: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 114,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 114,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 111
      },
      "11": {
        loc: {
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 115
      },
      "12": {
        loc: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 118
      },
      "13": {
        loc: {
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 118,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 118,
            column: 22
          }
        }, {
          start: {
            line: 118,
            column: 26
          },
          end: {
            line: 118,
            column: 41
          }
        }],
        line: 118
      },
      "14": {
        loc: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 123,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 121
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0cd2fb9d7675e4fe9903ff6fbc225ed5d031fab7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20a5p87m4q = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_20a5p87m4q();
cov_20a5p87m4q().s[0]++;
var getBeforeLoadAction = function getBeforeLoadAction() {
  cov_20a5p87m4q().f[0]++;
  cov_20a5p87m4q().s[1]++;
  return {
    type: 'PRODUCT_BEFORE_LOAD'
  };
};
cov_20a5p87m4q().s[2]++;
var getLoadSuccessAction = function getLoadSuccessAction(data, config) {
  cov_20a5p87m4q().f[1]++;
  cov_20a5p87m4q().s[3]++;
  return {
    type: 'PRODUCT_LOAD_SUCCESS',
    data: data,
    config: config
  };
};
cov_20a5p87m4q().s[4]++;
var getLoadErrorAction = function getLoadErrorAction() {
  cov_20a5p87m4q().f[2]++;
  cov_20a5p87m4q().s[5]++;
  return {
    type: 'PRODUCT_LOAD_ERROR'
  };
};
cov_20a5p87m4q().s[6]++;
var getCloneAction = function getCloneAction(product) {
  cov_20a5p87m4q().f[3]++;
  cov_20a5p87m4q().s[7]++;
  return {
    type: 'PRODUCT_CLONE',
    product: product
  };
};
cov_20a5p87m4q().s[8]++;
var getSelectOccurrenceAction = function getSelectOccurrenceAction(options) {
  cov_20a5p87m4q().f[4]++;
  cov_20a5p87m4q().s[9]++;
  return {
    type: 'PRODUCT_SELECT_OCCURRENCE',
    options: options
  };
};
cov_20a5p87m4q().s[10]++;
var getSetPriceAction = function getSetPriceAction(_ref) {
  var tariffs = _ref.tariffs,
    _ref$tariffsBySeatCat = _ref.tariffsBySeatCat,
    tariffsBySeatCat = _ref$tariffsBySeatCat === void 0 ? (cov_20a5p87m4q().b[0][0]++, {}) : _ref$tariffsBySeatCat;
  cov_20a5p87m4q().f[5]++;
  cov_20a5p87m4q().s[11]++;
  return {
    type: 'PRODUCT_SET_PRICE',
    tariffs: tariffs,
    tariffsBySeatCat: tariffsBySeatCat
  };
};

/*
 * The loader get the product data based on the id of the product we want to get
 * the options contains information we can pass to change the value returned
 * options may contain :
 *        -> productId (MANDATORY), that is obviously the id of the product we want.
 *        -> withPrice that is a boolean. By default it is falsed, must be passed to get prices
 *        -> offset that is a number to pass for pagination
 *        -> limit, Max number of products returned
 */
cov_20a5p87m4q().s[12]++;
var load = function load(config, options) {
  cov_20a5p87m4q().f[6]++;
  cov_20a5p87m4q().s[13]++;
  return function (dispatch) {
    cov_20a5p87m4q().f[7]++;
    cov_20a5p87m4q().s[14]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    var _ref2 = (cov_20a5p87m4q().s[15]++, options),
      productId = _ref2.productId,
      withPrice = _ref2.withPrice,
      offset = _ref2.offset,
      limit = _ref2.limit,
      maxOccurrences = _ref2.maxOccurrences;

    // then fetch the product
    cov_20a5p87m4q().s[16]++;
    return (0, _gAxios.default)("".concat(config.restHost, "/v1/products/").concat(productId, "?additionalFields=occurrences,simplePrices").concat(withPrice ? (cov_20a5p87m4q().b[1][0]++, ',prices') : (cov_20a5p87m4q().b[1][1]++, '') // by default prices are not part of the
    ).concat(maxOccurrences ? (cov_20a5p87m4q().b[2][0]++, "&maxOccurrences=".concat(maxOccurrences)) : (cov_20a5p87m4q().b[2][1]++, ''), "&includeMetadata=true").concat(offset ? (cov_20a5p87m4q().b[3][0]++, "&offset=".concat(offset)) : (cov_20a5p87m4q().b[3][1]++, '')).concat(limit ? (cov_20a5p87m4q().b[4][0]++, "&limit=".concat(limit)) : (cov_20a5p87m4q().b[4][1]++, '')).concat(config.productOwnerNumber ? (cov_20a5p87m4q().b[5][0]++, "&productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_20a5p87m4q().b[5][1]++, '')), {
      headers: config.headers
    }).then(function (response) {
      cov_20a5p87m4q().f[8]++;
      cov_20a5p87m4q().s[17]++;
      if ((cov_20a5p87m4q().b[7][0]++, response.status >= 200) && (cov_20a5p87m4q().b[7][1]++, response.status < 300)) {
        cov_20a5p87m4q().b[6][0]++;
        var state = (cov_20a5p87m4q().s[18]++, dispatch(getLoadSuccessAction((cov_20a5p87m4q().b[8][0]++, response.data) && (cov_20a5p87m4q().b[8][1]++, response.data.product),
        // the server return a { product : {}} instead of the object representing the product itself
        config)));
        cov_20a5p87m4q().s[19]++;
        return {
          data: response.data,
          state: state
        };
      } else {
        cov_20a5p87m4q().b[6][1]++;
      }
      var error = (cov_20a5p87m4q().s[20]++, new Error("".concat(response.status, " (").concat(response.statusText, ")")));
      cov_20a5p87m4q().s[21]++;
      error.response = (cov_20a5p87m4q().b[9][0]++, response.json()) || (cov_20a5p87m4q().b[9][1]++, response);
      cov_20a5p87m4q().s[22]++;
      throw error;
    }).catch(function (response) {
      cov_20a5p87m4q().f[9]++;
      cov_20a5p87m4q().s[23]++;
      dispatch(getLoadErrorAction());
      cov_20a5p87m4q().s[24]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_20a5p87m4q().s[25]++;
      return response;
    });
  };
};

/**
 * function to copy data receive from another product
 * WARNING : no check are done on data correctness
 */
cov_20a5p87m4q().s[26]++;
var clone = function clone(product) {
  cov_20a5p87m4q().f[10]++;
  cov_20a5p87m4q().s[27]++;
  return function (dispatch) {
    cov_20a5p87m4q().f[11]++;
    cov_20a5p87m4q().s[28]++;
    return dispatch(getCloneAction(product));
  };
};

/**
 * A product can contain a list of performances or occurrences
 * This function allow to "select" one of them  (i.e. remove all performances but the one selected)
 * options can contain :
 * OccurrenceId -> will be chosen if exist
 * default -> the possible values : ['FIRST']
 */
cov_20a5p87m4q().s[29]++;
var selectOccurrence = function selectOccurrence(options) {
  cov_20a5p87m4q().f[12]++;
  cov_20a5p87m4q().s[30]++;
  return function (dispatch) {
    cov_20a5p87m4q().f[13]++;
    cov_20a5p87m4q().s[31]++;
    return dispatch(getSelectOccurrenceAction(options));
  };
};
/**
 * Set the prices to the product from another product
 * @param {ProductType} product
 */
cov_20a5p87m4q().s[32]++;
var setPrice = function setPrice(product) {
  cov_20a5p87m4q().f[14]++;
  cov_20a5p87m4q().s[33]++;
  return function (dispatch, getState) {
    cov_20a5p87m4q().f[15]++;
    var state = (cov_20a5p87m4q().s[34]++, getState());
    var tariffs;
    var tariffsBySeatCat;
    cov_20a5p87m4q().s[35]++;
    if (!(0, _isEmpty.default)(product.performances)) {
      cov_20a5p87m4q().b[10][0]++;
      cov_20a5p87m4q().s[36]++;
      tariffs = (0, _get.default)(product, 'performances[0].tariffs');
      cov_20a5p87m4q().s[37]++;
      tariffsBySeatCat = (0, _get.default)(product, 'performances[0].tariffsBySeatCat');
    } else {
      cov_20a5p87m4q().b[10][1]++;
    }
    cov_20a5p87m4q().s[38]++;
    if (!(0, _isEmpty.default)(product.timeslots)) {
      cov_20a5p87m4q().b[11][0]++;
      cov_20a5p87m4q().s[39]++;
      tariffs = (0, _get.default)(product, 'timeslots[0].tariffs');
    } else {
      cov_20a5p87m4q().b[11][1]++;
    }
    cov_20a5p87m4q().s[40]++;
    if ((cov_20a5p87m4q().b[13][0]++, (0, _isEmpty.default)(tariffs)) && (cov_20a5p87m4q().b[13][1]++, product.tariffs)) {
      cov_20a5p87m4q().b[12][0]++;
      cov_20a5p87m4q().s[41]++;
      tariffs = product.tariffs;
    } else {
      cov_20a5p87m4q().b[12][1]++;
    }
    cov_20a5p87m4q().s[42]++;
    if (!(0, _isEmpty.default)(tariffs)) {
      cov_20a5p87m4q().b[14][0]++;
      cov_20a5p87m4q().s[43]++;
      return dispatch(getSetPriceAction({
        tariffs: tariffs,
        tariffsBySeatCat: tariffsBySeatCat
      }));
    } else {
      cov_20a5p87m4q().b[14][1]++;
    }
    cov_20a5p87m4q().s[44]++;
    return state;
  };
};
var _default = exports.default = {
  load: load,
  clone: clone,
  selectOccurrence: selectOccurrence,
  setPrice: setPrice
};